/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2022-11-01 16:43:01
 * @LastEditTime: 2023-10-10 16:08:45
 * @LastEditors: WangYuhan
 */
import moment from 'moment';
import Vue from 'vue';

const install = function () {
  /**
   * @name:
   * @param level {string}
   * @param type {string}
   * @param name {string}
   * @param info {string}
   * @Description:
   * @author lijiamin
   * @date 2022/2/16
   */
  Vue.prototype.logEvent = function (level, type, name, info = '无') {
    if (level && type && name && info) {
      const log = {
        level: level,
        type: type,
        page: window.location.href,
        name: name,
        date: moment().format('yyyy-MM-DD HH:mm:ss'),
        info: info,
      };
      const logs = window.localStorage.getItem('logs')
        ? JSON.parse(window.localStorage.getItem('logs'))
        : [];
      logs.push(log);
      if (logs.length > 100) {
        logs.splice(0, logs.length - 100);
      }
      window.localStorage.setItem('logs', JSON.stringify(logs));
    }
  };
  // 异常事件捕获
  const errorHandler = (error, vm) => {
    console.error('抛出全局异常', vm, error);
    const err = {
      level: 'DeBug',
      type: 'function',
      page: window.location.href,
      name: '函数异常',
      date: moment().format('yyyy-MM-DD HH:mm:ss'),
      info: error.toString(),
    };
    const logs = window.localStorage.getItem('logs')
      ? JSON.parse(window.localStorage.getItem('logs'))
      : [];
    logs.push(err);
    if (logs.length > 100) {
      logs.splice(0, logs.length - 100);
    }

    window.localStorage.setItem('logs', JSON.stringify(logs));
  };
  Vue.config.errorHandler = errorHandler;
  Vue.prototype.$throw = error => errorHandler(error, this);
};

export default install;
